import type React from 'react';
import { expandedContainer } from './expandedContainer.styles';

export type ExpandedContainerProps = {
  children: React.ReactNode;
};

/**
 * ExpandedContainer - Full-width container for expanded HDP mode
 *
 * Displays at full viewport width (100vw) on all breakpoints.
 * Standard document flow (not fixed positioning).
 */
export const ExpandedContainer = ({ children }: ExpandedContainerProps) => {
  return <div className={expandedContainer}>{children}</div>;
};
